import sublimationPrinting from "./templates/sublimation-printing";

export default [
  {
    id: `description`,
    title: `О товаре`,
  },
  {
    id: `material`,
    title: `Описание`,
    content: {
      description: `
        <p>
          Для ноутбука с диагональю до 12".<br>
          Яркая и насыщенная печать с обеих сторон чехла. Принт не чувствуется на ощупь и не стирается. По длинной стороне чехла располагается аккуратная молния. Чехол из ткани неопрен. Гладкий снаружи и плотный внутри, а толщина ткани обеспечит надежную защиту от ударов.
        </p>
        <p>
          <strong>Материалы:</strong><br>
          Неопрен.
        </p>
        <p>
          <strong>Размеры:</strong><br>
          Для ноутбука с диагональю до 12".<br>
          Ширина: 31 см.<br>
          Высота: 25 см.<br>
          Диагональ: 36-37 см.
        </p>`
    }
  },
  {
    id: `printing`,
    title: `Способ печати`,
    content: {
      printingInfo: `${sublimationPrinting}`
    }
  },
  {
    id: `price`,
    title: `Цены`
  },
  {
    id: `delivery`,
    title: `Доставка и оплата`
  },
  {
    id: `reviews`,
    title: `Отзывы`
  }
];
